import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TecnicoResponsable } from './entity-tecnico-responsable.model';

@Injectable({
  providedIn: 'root'
})
export class TecnicoResponsableService {
  url: string;
  token: string;
  endpoint = 'tecnicosResponsable';

  constructor(private http: HttpClient) {}

  getTecnicoResponsable(): Observable<TecnicoResponsable[]> {
    return this.http.get<TecnicoResponsable[]>(
      `${this.url}/${this.endpoint}/`,
      {
        params: { token: this.token }
      }
    );
  }

  addTecnicoResponsable(
    tecnicoResponsable: TecnicoResponsable
  ): Observable<TecnicoResponsable> {
    return this.http.post<TecnicoResponsable>(`${this.url}/${this.endpoint}/`, {
      ...tecnicoResponsable
    });
  }

  changeTecnicoResponsable(
    tr: TecnicoResponsable
  ): Observable<TecnicoResponsable> {
    return this.http.patch<TecnicoResponsable>(
      `${this.url}/${this.endpoint}/${tr.id}/`,
      {
        ...tr
      }
    );
  }

  deleteTecnicoResponsable(
    p: TecnicoResponsable
  ): Observable<TecnicoResponsable> {
    return this.http.delete<TecnicoResponsable>(
      `${this.url}/${this.endpoint}/${p.id}`,
      {
        params: { token: this.token }
      }
    );
  }
}
